// export const BASE_URL_MOKE = 'https://sltmobitel.mocklab.io'

let BASE_URL = "http://172.25.41.153:8888";
let BASE_URL_MOKE = "https://sltmobitel.mocklab.io";
export const BASE_URL_SLT_MOBITEL = "https://slt.lk";
// export const BASE_URL_SLT_MOBITEL = 'http://124.43.132.75';

if (process.env.REACT_APP_ENV === "DEVELOPMENT") {
  BASE_URL = "http://localhost:9092";
} else if (process.env.REACT_APP_ENV === "TESTING") {
  // BASE_URL = "http://link.lakmobile.com:9092";
  BASE_URL = "https://enttestnode1api.slt.lk";
} else if (process.env.REACT_APP_ENV === "PRODUCTION") {
  BASE_URL = "https://entcpanelapi.slt.lk"; //'https://172.25.41.153:8888'
} else if (process.env.REACT_APP_ENV === "STAGING") {
  //BASE_URL = "https://enttestnode1api.slt.com.lk:8888";
  BASE_URL = "https://172.25.40.235:8888";
}

export { BASE_URL, BASE_URL_MOKE };

// export const EXTERNAL_USER_AUTHENTICATE = BASE_URL + "/external/authenticate";
export const EXTERNAL_USER_AUTHENTICATE =
  BASE_URL + "/v2/external/authenticate";

export const refreshTokenUrl = BASE_URL + "/api/external/refreshToken";

export const GET_EXTERNAL_USER_BY_ACCESS_TOKEN =
  BASE_URL + "/api/v1/external-users/by-token";

export const GET_CUSTOMER_INDENTITY_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.CustomerAccountDataAPI/api/CustomerAccount/CheckCustomerIdentity";

export const GET_CUSTOMER_INDENTITY_ACCOUNT_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.CustomerAccountDataAPI/api/CustomerAccount/CheckCustomerAccountNumber";

export const GET_BILL_FAULTS_Url = BASE_URL + "/api/bill-faults";

export const PAYMENTSUMMARY_Url =
  BASE_URL + "/api/v1/billpay.slt.lk/confirm.php";

export const FAULT_NATURE_OF_SERVICE_Url = BASE_URL_MOKE + "/api/v1/faults/lov";
export const FAULT_NATURE_OF_BILL_Url = BASE_URL_MOKE + "/api/v1/bills/lov";

export const EXTERNAL_USER_Url = BASE_URL + "/api/v1/external-users";
export const EXTERNAL_ROLE_Url = BASE_URL + "/api/v1/roles/external-users";
export const ASSIGN_PRIVILEGES_Url = BASE_URL + "/api/v1/users";
export const CIRCUITS_Url = BASE_URL + "/api/v1/circuits";
export const CHANGEPORTALPASSWORD_Url =
  BASE_URL + "/api/v1/external-users/reset-password";

export const GET_ROLE_BY_ID_Url = BASE_URL + "/api/v1/roles";

export const GET_SERVICE_FAULT_HISTORY_BY_DATE_RANGE_Url =
  BASE_URL_MOKE + "/api/v1/faults/cct-id/";

export const GET_DATA_WITH_PRODUCT_ATTRIBUTES_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.CustomerAccountDataAPI/api/CustomerAccount/GetDataWithProductAttributes";

export const GET_NATURE_OF_COMPLAIN_Url = BASE_URL + "/api/faults/service";

export const GET_ACCOUNT_NUMBERS_BY_TOCKEN_Url =
  BASE_URL + "/api/v1/external-users/account-numbers";

export const CHANGE_NICKNAME_Url =
  BASE_URL + "/api/external-users/save-nickname";

export const CHANGE_NICKNAME_BROADBAND_Url =
  BASE_URL + "/api/v1/circuit-nickname";

export const GET_ProductNameByForm_Url =
  BASE_URL + "/api/request-forms/product-name/";

export const FORM_NAME_URL = BASE_URL + "/api/request-forms/form-name/";

export const SUBMIT_FORM_URL = BASE_URL + "/api/submit-form";

export const FORM_CATOGERY_URL =
  BASE_URL + "/api/request-forms/form-names-and-category";

// fault
export const FAULT_SERVICE_ASSURANCE_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.ServiceAssuaranceAPI/api/ServiceAssuarance";

// fault
export const ORDER_STATUS_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.ServiceFulfilmentAPI/api/ServiceFulfilment/GetOrderStatus";

// New Service
export const NEW_REQUEST_STATUS_Url = BASE_URL + "/api/service-requests/status";

// service relocation
export const FAULT_SERVICE_RELOCATION_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.ServiceAssuaranceAPI/api/ServiceAssuarance/CreateRelocationRequest";

// Dashboard
export const DASHBOARD_DATA_Url =
  BASE_URL + "/api/v1/EnterprisePortal.DashBoardAPI/api";

// Billing
export const GET_BILL_DETAILS_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.BillingAPI/api/BillInquiry/GetBillDetails";

export const GET_BILL_HISTORY_Url =
  BASE_URL +
  "/api/v1/EnterprisePortal.BillingAPI/api/BillInquiry/GetBillHistory";

export const BILLING_BASE_Url =
  BASE_URL + "/api/v1/EnterprisePortal.BillingAPI/api";

// Forget Password
export const FORGET_PASSWORD_OTP_SEND_Url =
  BASE_URL + "/api/v1/external-users/forget-password";
export const FORGET_PASSWORD_RESET_Url =
  BASE_URL + "/api/v1/external-users/forget-password/reset";

export const VERIFY_USER_LOGIN_Url = BASE_URL + "/external/verify-otp";

// export const OTP_REQUEST_Url = BASE_URL + "/api/v1/external-users/otp-request";
export const OTP_REQUEST_Url = BASE_URL + "/external/resend-otp";
export const UPDATE_FIRST_TIME_PASSWORD_Url =
  BASE_URL + "/api/v1/external-users/create-password";

// Intelligence solution
export const ENTERPRISE_LANDING_DESCRIPTION_Url =
  BASE_URL_SLT_MOBITEL + "/business-landing-description";
export const SME_LANDING_DESCRIPTION_Url =
  BASE_URL_SLT_MOBITEL + "/sme-business-landing-description";

export const GET_DATA_ADD_ONS_URL = "/api/data-add-ons";
export const ADD_DATA_ADD_ON_URL = "/api/data-add-ons/add";
